import * as yup from "yup";

export const repoterschema = yup.object().shape({
  // fullName: yup.string().required("FullName is required"),
  // role: yup.string().required("Role is required"),
});
